export default __webpack_public_path__ + "static/media/46.90bd83df.png";